/* Raghu 27/10/2022 3225736869 Card alignment fixes
Prakash 12/06/2022 3225736869 Removed card component.
Ashraf 12/16/2022 3225736869 fixed role based access.

*/
import React, {useContext, useEffect} from 'react';
import Tabs from './Tabs';
import {ThemeContext} from '../../../../themes/ThemeProvider';

const RuleGroup = ({setTabValue, groupId, RMbreCode, roleDataNJobs, setSelected}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  useEffect(() => {
    setSelected && setSelected(false);
  }, []);

  return (
    <>
      <div className={`${classes.cardStyleWhite}`}>
        <Tabs setSelected={setSelected} groupId={groupId} setTabValue={setTabValue} roleDataNJobs={roleDataNJobs}/>
      </div>
    </>
  );
};

export default RuleGroup;
